import img from '../../Styles/Images/Dog.png';

export const DogIllustration = () => {
  return (
    <div>
      <img style={{ width: '100%' }} src={img} alt='dog illustration' />
    </div>
  );
};
